import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body, html  {
    height: 100%;
    
    overscroll-behavior: none;
  }

  #root {
    height: 100%;
  }

  button {
    font-family: Poppins, sans-serif;
    
    cursor: pointer;
  }

  body {
    padding: 0;
    margin: 0;

    position: relative;

    background-color: #f5f5fc;

    font-family: Poppins, sans-serif;
    font-size: 14px;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
